export default __webpack_public_path__ + "static/mila-88978d38ace3663ca535c9697e06151b.png";